export const TABLET_WIDTH = '1000px';
export const PHONE_WIDTH = '650px';
